<template>
    <modal :show="show" @close="close" :closeOnbackdrop="false">
        <template slot="header"><h3>User Bulk Edits</h3></template>
        <template>
            <div class="row" v-if="managers">
                <div class="col-md-12">
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Special Role</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="special_role" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ame="role" v-model="model.special_role" @change="specialDefaults">
                            <option></option>
                            <option v-for="(role, p) in special_roles" :key="p" :value="role.role">{{ role.name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Primary Role</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="role" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="role" name="role" v-model="model.role">
                            <option v-for="(role, p) in roles" :key="p" :value="role.role">{{ role.name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Secondary Role</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="extra_roles" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" name="role" v-model="model.extra_roles" multiple>
                            <option v-for="(role, p) in roles" :key="p" :value="role.role" :selected="model.extra_roles && model.extra_roles.includes(role.role)">{{ role.name }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12" v-if="model.role == 'project-manager'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Can Approve</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="can_approve" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="can_approve" name="can_approve" v-model="model.can_approve">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12" v-if="model.role != 'project-manager'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Project Manager</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="pm" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="pm" name="pm" v-model="model.pm">
                            <option v-for="(pm, p) in pms" :key="p" :value="pm.username">{{ pm.username }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Manager</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="managers" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" name="managers" v-model="model.managers">
                            <option v-for="(pm, p) in managers" :key="p" :value="pm.username">{{ pm.username }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Distributor</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="distributor" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" name="distributor" v-model="model.distributor">
                            <option value=""></option>
                            <option v-for="(pm, p) in distributors" :key="p" :value="pm.username">{{ pm.username }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Email report</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="receive_email" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="receive_email" name="receive_email" v-model="model.receive_email">
                            <option value="1">Enabled</option>
                            <option value="0">Disabled</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Purchasing Type</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="can_purchase" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="can_purchase" name="can_purchase" v-model="model.can_purchase">
                            <option value="1">Can Purchase (Own and Subs)</option>
                            <option value="2">Own Projects Only</option>
                            <option value="3">Request Purchase Only</option>
                            <option value="4">Requested Only</option>
                            <option value="0">Not Allowed</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Pricing</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="pricing" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="pricing" name="pricing" v-model="model.pricing">
                            <option value="1">Enabled</option>
                            <option value="0">Disabled</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Drop Ship Fee</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="add_dropship" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="add_dropship" name="add_dropship" v-model="model.add_dropship">
                            <option value="0">US Logic</option>
                            <option value="1">Non-US Logic</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">CAD File Download</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="download_cad" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="download_cad" name="download_cad" v-model="model.download_cad">
                            <option value="0">Not Allowed</option>
                            <option value="1">Allowed</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">3D File Download</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="download_3d" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="download_3d" name="download_3d" v-model="model.download_3d">
                            <option value="0">Not Allowed</option>
                            <option value="1">Allowed</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">5001 Machines</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="allow_5001" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="allow_5001" name="allow_5001" v-model="model.allow_5001">
                            <option value="0">Not Allowed</option>
                            <option value="1">Allowed</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">KEB Green</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="kebgrn" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="kebgrn" name="kebgrn" v-model="model.kebgrn">
                            <option value="0">Not Allowed</option>
                            <option value="1">Allowed</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Stock Option</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="no_stock" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="no_stock" name="no_stock" v-model="model.no_stock">
                            <option value="1">Not Allowed</option>
                            <option value="0">Allowed</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Go Custom when Gearless with Otis Drive</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="custom_otis_gearless" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="custom_otis_gearless" name="custom_otis_gearless" v-model="model.custom_otis_gearless">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Add "Special Order Paint"</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="special_paint" v-model="edit_fields"> Change</label>
                        </div>
                        <select class="form-control" ref="special_paint" name="special_paint" v-model="model.special_paint">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Discount (%)</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="discount" v-model="edit_fields"> Change</label>
                        </div>
                        <input type="number" min="0" max="100" class="form-control" ref="discount" name="discount" v-model="model.discount">
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Lead Time</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="lead_time" v-model="edit_fields"> Change</label>
                        </div>
                        <input type="number" min="0" max="99" class="form-control" v-model="model.lead_time">
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Minimum Rope Number</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="min_rope" v-model="edit_fields"> Change</label>
                        </div>
                        <input type="number" min="0" max="99" class="form-control" v-model="model.min_rope">
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Sales Employee</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="sales" v-model="edit_fields"> Change</label>
                        </div>
                        <input type="text" min="0" max="100" class="form-control" v-model="model.sales">
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Pads on Floors</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="can_pads_on_floors" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="can_pads_on_floors" v-model="model.can_pads_on_floors" class="form-control" name="can_pads_on_floors">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Dura Lift Sheave</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="dura_lift_sheave" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="dura_lift_sheave" v-model="model.dura_lift_sheave" class="form-control" name="dura_lift_sheave">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Wire Rope & Comp Default</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="wire_rope" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="wire_rope" v-model="model.wire_rope" class="form-control" name="wire_rope">
                            <option value="1">Checked</option>
                            <option value="0">Not Checked</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Hyperion Price List
                                <input 
                                    id="setting_hpl"
                                    ref="hyperion_price_list"
                                    v-model="model.hyperion_price_list"
                                    type="checkbox"
                                    name="setting_hpl"
                                    class="setting_hpl"
                                    @change="handleHplChange">
                            </label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="hyperion_price_list" v-model="edit_fields"> Change</label>
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Consulted Rope Manufacturer</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="consulted_rope_manufacturer" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="consulted_rope_manufacturer" v-model="model.consulted_rope_manufacturer" class="form-control" name="consulted_rope_manufacturer">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Quote TK Machines</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="tk_machine" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="tk_machine" v-model="model.tk_machine" class="form-control" name="tk_machine">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Always Add Rope Lubricator</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="rope_lubricator_option" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="rope_lubricator_option" v-model="model.rope_lubricator_option" class="form-control" name="rope_lubricator_option">
                            <option value="No">No</option>
                            <option value="RLU">RLU</option>
                            <option value="RPLU">RPLU</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Quote Validity</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="quote_validity" v-model="edit_fields"> Change</label>
                        </div>
                        <input type="number" min="90" max="1000" class="form-control" required ref="quote_validity" name="quote_validity" v-model="model.quote_validity">
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Allowable # of trips for Rope Life</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="ropelife_trips" v-model="edit_fields"> Change</label>
                        </div>
                        <input type="number" min="0" class="form-control" required ref="ropelife_trips" name="ropelife_trips" v-model="model.ropelife_trips">
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Special PDFs</label>
                            <label class="no-wrap font-weight-normal"><input type="checkbox" value="special_pdfs" v-model="edit_fields"> Change</label>
                        </div>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="width: 60%;">PDF</th>
                                    <th style="width: 30%;">Orientation</th>
                                    <th style="witdh: 10%;"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(pdf, key) in special_pdfs" :key="key">
                                    <td>
                                        <template v-if="!pdf.path">
                                            <input type="file" :ref="`special_pdf_file${key}`" class="form-control" accept="application/pdf" :required="key > 0">
                                        </template>
                                        <template v-else>
                                            <div class="pdf-link">
                                                <div class="d-flex align-items-center">
                                                    <a :href="pdf.path" target="_blank"><span class="fa fa-file-pdf"></span></a>
                                                    <button class="btn btnEditFile ml-2" type="button" @click="pdf.path = ''"><span class="fa fa-edit"></span></button>
                                                </div>
                                                <a :href="pdf.path" target="_blank" class="mt-2 d-block">{{ pdf.path.replace(/^.*[\\\/]/, '') }}</a>
                                            </div>
                                        </template>
                                    </td>
                                    <td>
                                        <select class="form-control" v-model="pdf.orientation">
                                            <option value="L">Landscape</option>
                                            <option value="P">Portrait</option>
                                        </select>
                                    </td>
                                    <td>
                                        <div class="row-btns">
                                            <button class="btn btnAddPdfRow" type="button" @click="add_pdf_row('special')"><span class="fa fa-plus"></span></button>
                                            <button class="btn btnRemovePdfRow" type="button" @click="remove_pdf_row('special', pdf.id, key)"><span class="fa fa-close"></span></button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
        <template slot="footer">
            <button class="btn btn-black" :disabled="isSubmitting" @click="submit_form">
                <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Update</template>
            </button>
        </template>
    </modal>
</template>
<script>
export default {
    data() {
        return {
            apiUrl: '/api/',
            isSubmitting: false,
            managers: false,
            pms: false,
            roles: false,
            distributors: false,
            model: {
                special_role: '',
                role: 'customer',
                extra_roles: '',
                can_approve: '0',
                pm: '',
                managers: '',
                distributors: '',
                receive_email: '0',
                can_purchase: '0',
                pricing: '0',
                add_dropship: '0',
                download_cad: '0',
                download_3d: '0',
                allow_5001: '0',
                kebgrn: '0',
                no_stock: '0',
                custom_otis_gearless: '0',
                special_paint: '0',
                lead_time: '14',
                min_rope: '',
                discount: '0',
                sales: '',
                can_pads_on_floors: '0',
                dura_lift_sheave: '0',
                consulted_rope_manufacturer: '0',
                tk_machine: '0',
                hyperion_price_list: 0,
                rope_lubricator_option: 'No',
                quote_validity: 90,
                ropelife_trips: 0
            },
            special_roles: [
                { role : 'otis-branch', name : 'Otis Branch' },
                { role : 'schindler-branch', name : 'Schindler Branch' },
                { role : 'tke-branch', name : 'TKE Branch' },
                { role : 'kone-branch', name : 'Kone Branch' },
                { role : 'otis-region', name : 'Otis Region' },
            ],
            role_defaults: {
                'otis-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 1,
                    lead_time : 14,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 2,
                    allow_5001 : 0,
                },
                'otis-region' : {
                    role : 'manager',
                    custom_otis_gearless : 1,
                    lead_time : 14,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 1,
                    allow_5001 : 0,
                },
                'schindler-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 0,
                    lead_time : 14,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 0,
                    allow_5001 : 0,
                },
                'tke-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 0,
                    lead_time : 14,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 0,
                    can_purchase : 0,
                    allow_5001 : 0,
                },
                'kone-branch' : {
                    role : 'customer',
                    custom_otis_gearless : 1,
                    lead_time : 14,
                    download_cad : 1,
                    download_3d : 0,
                    no_stock : 1,
                    can_purchase : 0,
                    allow_5001 : 0,
                    manager : 'KoneOps',
                },
            },
            special_pdfs: [{ path: '', orientation: 'L' }],
            edit_fields: []
        }
    },
    props: {
        show: Boolean,
        ids: Array
    },
    mounted() {
        this.getOptions()
    },
    methods: {
        specialDefaults() {
            if ( this.model.special_role && this.role_defaults[this.model.special_role] ) {
                this.model = { ...this.model, ...this.role_defaults[this.model.special_role] };
            }
        },
        getOptions() {
            const api = this.apiUrl+'user/47';
            this.$http.get(api).then((response) => {
                this.managers = response.data.managers;
                this.roles = response.data.roles;
                this.pms = response.data.pms;
                this.distributors = response.data.distributors;
            });
        },
        getPM() {
            return this.managers.map(function(o){
                if ( o.role == "project-manager" ) return o;
            });
        },
        submit_form() {
            this.isSubmitting = true
            let fdata = new FormData()

            for(let n in this.special_pdfs) {
                let file = ''
                if(this.$refs[`special_pdf_file${n}`]) {
                    if(this.$refs[`special_pdf_file${n}`][0]) {
                        file = this.$refs[`special_pdf_file${n}`][0].files[0]
                    }
                }
                fdata.append(`special_pdf_orientation[${n}]`, this.special_pdfs[n].orientation)
                fdata.append(`special_pdf_file[${n}]`, file)
            }

            for(let n in this.edit_fields) {
                fdata.append(`edit_fields[${n}]`, this.edit_fields[n])
            }

            for(let n in this.model) {
                fdata.append(n, this.model[n])
            }

            for(let n in this.ids) {
                fdata.append(`ids[${n}]`, this.ids[n])
            }

            this.$http.post('/api/users/bulk-edit', fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(() => {
                    this.isSubmitting = false
                    this.close()
                    this.reset_form()
                    alert('Updated!')
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        this.validation_error(error.response.data.errors)
                    }
                    this.isSubmitting = false
                })
        },
        add_pdf_row(type) {
            this[`${type}_pdfs`].push({ path: '', orientation: 'L' });
        },
        remove_pdf_row(type, id, key) {
            this[`${type}_pdfs`].splice(key, 1);
            if(this[`${type}_pdfs`].length == 0) {
                this[`${type}_pdfs`] = [{ path: '', orientation: 'L' }];
            }
        },
        close() {
            this.show = false
            this.$emit('close', true)
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError')
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                        ref.scrollIntoView()
                    }
                }
            }

            if(Object.keys(errors).length == 1) {
                alert(errors[Object.keys(errors)[0]][0])
            }
        },
        reset_form() {
            this.model = {
                special_role: '',
                role: 'customer',
                extra_roles: '',
                can_approve: '0',
                pm: '',
                managers: '',
                distributors: '',
                receive_email: '0',
                can_purchase: '0',
                pricing: '0',
                add_dropship: '0',
                download_cad: '0',
                download_3d: '0',
                allow_5001: '0',
                no_stock: '0',
                custom_otis_gearless: '0',
                special_paint: '0',
                lead_time: '14',
                min_rope: '',
                discount: '0',
                sales: '',
                can_pads_on_floors: '0',
                dura_lift_sheave: '0',
                consulted_rope_manufacturer: '0',
                tk_machine: '0',
                hyperion_price_list: 0,
                rope_lubricator_option: 'No',
                quote_validity: 90,
                ropelife_trips: 0
            }
            this.special_pdfs = [{ path: '', orientation: 'L' }]
            this.edit_fields = []
            this.ids = []
        },
        handleHplChange(event) {
            const isChecked = event.target.checked
            this.model.hyperion_price_list = isChecked ? 1 : 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.admin-fields { border: 1px solid #000; }
.admin-fields h3 {background: #000; color: #fff; font-weight: normal; font-size: 15px; text-transform: uppercase; padding: 6px 15px; margin: 0 -15px 15px; }
.table {
    width: 100%;
    th, td {
        padding: 0.5em;
    }
}
.btnAddPdfRow, .btnRemovePdfRow, .btnEditFile {
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 28px;
    padding: 0;
    float: right;
}
.btnAddPdfRow {
    background-color: #459e45;
    color: #fff;
    &:hover {
        color: #000;
    }
}
.fa-file-pdf {
    font-size: 30px;
}
.pdf-link {
    border: 1px solid #f2f2f2;
    border-radius: 4px;
    width: 160px;
    padding: 0.5em;
    overflow: hidden;
    white-space: nowrap;
}
.row-btns {
    width: 60px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.no-wrap {
    white-space: nowrap;
}
</style>